import { supabaseClient } from "@/lib/supabase";
import { queryOptions } from "@tanstack/react-query";
import {
    filterStaffBySecretaryOwnership,
    selectLinkedSecretaryIds,
} from "@/features/profile/api/filterStaffBySecretaryOwnership";
import { selectProfilesByRoles } from "@/features/profile/api/selectProfilesByRoles";

export interface ClinicianSecretaryOption {
    user_id: string;
    name: string | null;
}

export async function selectCliniciansAndSecretariesForOwnerFilter(
    viewerId: string
): Promise<ClinicianSecretaryOption[]> {
    const [data, linkedSecretaryIds, profileResult] = await Promise.all([
        selectProfilesByRoles({
            roles: ["CLINICIAN", "SECRETARY"],
            columns: "user_id, name, roles",
        }),
        selectLinkedSecretaryIds(viewerId),
        supabaseClient.from("profiles").select("is_super_user, roles").eq("user_id", viewerId).single(),
    ]);

    if (profileResult.error) throw profileResult.error;

    const viewerRoles = profileResult.data?.roles ?? [];
    const skipFilter = Boolean(profileResult.data?.is_super_user) || viewerRoles.includes("ADMIN");

    const filtered = filterStaffBySecretaryOwnership(data ?? [], linkedSecretaryIds, {
        skipFilter,
    });

    return filtered
        .filter((row) => row.user_id != null)
        .map((row) => ({ user_id: row.user_id as string, name: row.name }))
        .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, { sensitivity: "base" }));
}

export const clinicianSecretaryOwnerFilterQueryOptions = (viewerId: string) =>
    queryOptions({
        queryKey: ["templates-filter", "clinicians-secretaries", viewerId],
        queryFn: () => selectCliniciansAndSecretariesForOwnerFilter(viewerId),
        enabled: Boolean(viewerId),
    });
